import { useState, useEffect, ReactNode } from 'react'
import { Link } from 'gatsby'
import { Header as BaseHeader } from '@stratascratch/ui'
import { useAuth } from '@stratascratch/authentication'
import { PLATFORM_BASE_URL } from '../constants'
import SearchButton from './SearchButton'

function Header() {
  const { isAuthenticated, logout } = useAuth()

  const [currentHref, setCurrentHref] = useState<string | null>(null)

  useEffect(() => {
    if (window.location) setCurrentHref(window.location.toString())
  }, [])

  const pathname = (currentHref && new URL(currentHref).pathname) || undefined

  return (
    <BaseHeader
      isAuthenticated={isAuthenticated}
      pathname={pathname}
      handleLogout={logout}
      renderGatsbyLink={({ href, children, ...rest }) =>
        href && (
          <Link to={href} {...rest}>
            {children as ReactNode}
          </Link>
        )
      }
      renderPlatformLink={({ href, children, ...rest }) => (
        <a href={`${PLATFORM_BASE_URL}${href}`} {...rest}>
          {children as ReactNode}
        </a>
      )}
      renderSearch={<SearchButton />}
    />
  )
}

export default Header
